/**
 * `onEscapeKeyDown` of a dialog holding a picker: Escape first closes the open suggestion list,
 * and only a second Escape closes the dialog.
 */
export function keepOpenWhileListOpen(event: KeyboardEvent): void {
  const target = event.target;
  if (
    target instanceof HTMLElement &&
    target.getAttribute('role') === 'combobox' &&
    target.getAttribute('aria-expanded') === 'true'
  ) {
    event.preventDefault();
  }
}
